import axios from 'axios'
import apiConfig from '../apiConfig'

const { getImageVersionsApi, imageAnnotationsApi } = apiConfig

export const getImageVersionsService = (fileName) => {
  return axios.get(`${getImageVersionsApi}`, {
    params: { image_name: fileName, key: apiConfig?.apiKey ?? '' },
  })
}

export const getImageAnnotationsService = (fileName, version) => {
  return axios.get(`${imageAnnotationsApi}`, {
    params: {
      image_name: fileName,
      version: version,
      key: apiConfig?.apiKey ?? '',
    },
  })
}

export const addImageAnnotationsService = (data = '') => {
  const url = `${imageAnnotationsApi}`
  return axios.post(url, data, {
    params: {
      key: apiConfig?.apiKey ?? '',
    },
  })
}

export const updateImageAnnotationsService = (id, data = {}) => {
  const url = `${imageAnnotationsApi}/${id}`
  return axios.put(url, data, {
    params: {
      key: apiConfig?.apiKey ?? '',
    },
  })
}

export const deleteImageAnnotationsService = (id) => {
  const url = `${imageAnnotationsApi}/${id}`
  return axios.delete(url, {
    params: {
      key: apiConfig?.apiKey ?? '',
    },
  })
}

export const getImageAnnotationsInBulkService = (images = []) => {
  return axios.post(
    `${imageAnnotationsApi}/unresolved`,
    { images },
    {
      params: {
        key: apiConfig?.apiKey ?? '',
      },
    }
  )
}
